/* Gopi Vaid - product detail page behaviour. Namespaced, no dependencies. */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }

  function init(root) {
    if (!root || root.dataset.gvpReady === '1') { return; }
    root.dataset.gvpReady = '1';

    var data = {};
    var dataEl = root.querySelector('[data-gvp-data]');
    if (dataEl) {
      try { data = JSON.parse(dataEl.textContent); } catch (e) { data = {}; }
    }
    var variants = data.variants || [];

    /* ------------------------------------------------------------ gallery */
    var track = root.querySelector('[data-gvp-track]');
    var slides = track ? Array.prototype.slice.call(track.querySelectorAll('[data-gvp-slide]')) : [];
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-gvp-dot]'));
    var prevBtn = root.querySelector('[data-gvp-prev]');
    var nextBtn = root.querySelector('[data-gvp-next]');
    var current = 0;

    function goTo(i) {
      if (!track || !slides.length) { return; }
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
    }

    function paint(i) {
      current = i;
      dots.forEach(function (d, di) { d.classList.toggle('is-active', di === i); });
      if (prevBtn) { prevBtn.disabled = i === 0; }
      if (nextBtn) { nextBtn.disabled = i === slides.length - 1; }
    }

    function readIndex() {
      if (!track || !slides.length) { return; }
      var mid = track.scrollLeft + track.clientWidth / 2;
      var best = 0;
      var bestDist = Infinity;
      slides.forEach(function (s, si) {
        var c = s.offsetLeft - track.offsetLeft + s.clientWidth / 2;
        var d = Math.abs(c - mid);
        if (d < bestDist) { bestDist = d; best = si; }
      });
      if (best !== current) { paint(best); }
    }

    if (track) {
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) { return; }
        ticking = true;
        window.requestAnimationFrame(function () { readIndex(); ticking = false; });
      }, { passive: true });
    }

    dots.forEach(function (d, di) {
      d.addEventListener('click', function () { goTo(di); paint(di); });
    });
    if (prevBtn) { prevBtn.addEventListener('click', function () { goTo(current - 1); }); }
    if (nextBtn) { nextBtn.addEventListener('click', function () { goTo(current + 1); }); }
    paint(0);

    /* ----------------------------------------------------------- lightbox */
    var lb = root.querySelector('[data-gvp-lb]');
    var lbImg = root.querySelector('[data-gvp-lb-img]');
    var lbNow = root.querySelector('[data-gvp-lb-now]');
    var sources = slides.map(function (s) {
      var img = s.querySelector('img');
      return img ? (img.getAttribute('data-gvp-full') || img.currentSrc || img.src) : '';
    });
    var lbIndex = 0;

    function lbShow(i) {
      if (!lb || !sources.length) { return; }
      lbIndex = (i + sources.length) % sources.length;
      if (lbImg) { lbImg.src = sources[lbIndex]; }
      if (lbNow) { lbNow.textContent = String(lbIndex + 1); }
    }

    function lbOpen(i) {
      if (!lb) { return; }
      lbShow(i);
      lb.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
    }

    function lbClose() {
      if (!lb) { return; }
      lb.classList.remove('is-open');
      document.documentElement.style.overflow = '';
    }

    slides.forEach(function (s, si) {
      var img = s.querySelector('img');
      if (img) { img.addEventListener('click', function () { lbOpen(si); }); }
    });

    var lbCloseBtn = root.querySelector('[data-gvp-lb-close]');
    var lbPrev = root.querySelector('[data-gvp-lb-prev]');
    var lbNext = root.querySelector('[data-gvp-lb-next]');
    if (lbCloseBtn) { lbCloseBtn.addEventListener('click', lbClose); }
    if (lbPrev) { lbPrev.addEventListener('click', function () { lbShow(lbIndex - 1); }); }
    if (lbNext) { lbNext.addEventListener('click', function () { lbShow(lbIndex + 1); }); }
    if (lb) {
      lb.addEventListener('click', function (e) { if (e.target === lb) { lbClose(); } });
    }

    /* -------------------------------------------------------------- modal */
    var modalOpener = null;
    var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';

    function openModal(id, opener) {
      var m = document.getElementById(id);
      if (!m) { return; }
      modalOpener = opener || document.activeElement;
      m.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      m.dispatchEvent(new CustomEvent('gvp:modal-open'));
      var card = m.querySelector('.gvp-modal-card');
      if (card) {
        try { card.focus({ preventScroll: true }); } catch (err) { card.focus(); }
      }
    }

    function closeModal(m) {
      if (!m || !m.classList.contains('is-open')) { return; }
      m.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      if (modalOpener && typeof modalOpener.focus === 'function') {
        try { modalOpener.focus({ preventScroll: true }); } catch (err) { modalOpener.focus(); }
      }
      modalOpener = null;
    }

    /* keep Tab inside an open modal */
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') { return; }
      var m = root.querySelector('.gvp-modal.is-open');
      if (!m) { return; }
      var items = Array.prototype.filter.call(m.querySelectorAll(FOCUSABLE), function (el) {
        return el.offsetWidth > 0 || el.offsetHeight > 0;
      });
      if (!items.length) { return; }
      var first = items[0];
      var last = items[items.length - 1];
      var active = document.activeElement;
      if (e.shiftKey && (active === first || !m.contains(active) || active.classList.contains('gvp-modal-card'))) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && (active === last || !m.contains(active))) {
        e.preventDefault();
        first.focus();
      }
    });

    root.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-gvp-open]');
      if (opener) {
        e.preventDefault();
        openModal(opener.getAttribute('data-gvp-open'), opener);
        return;
      }
      var closer = e.target.closest('[data-gvp-close]');
      if (closer) {
        e.preventDefault();
        closeModal(closer.closest('.gvp-modal'));
      }
    });

    Array.prototype.forEach.call(root.querySelectorAll('.gvp-modal'), function (m) {
      m.addEventListener('click', function (e) {
        if (e.target.classList.contains('gvp-modal-veil')) { closeModal(m); }
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') { return; }
      if (lb && lb.classList.contains('is-open')) { lbClose(); }
      Array.prototype.forEach.call(root.querySelectorAll('.gvp-modal.is-open'), closeModal);
    });

    /* --------------------------------------------------------- accordions */
    var accs = Array.prototype.slice.call(root.querySelectorAll('[data-gvp-acc]'));

    accs.forEach(function (acc) {
      var body = acc.querySelector('[data-gvp-acc-body]');
      if (!body) { return; }
      var inner = body.firstElementChild;

      function setHeight(open) {
        if (!inner) { return; }
        if (open) {
          body.style.height = inner.offsetHeight + 'px';
          window.setTimeout(function () {
            if (acc.open) { body.style.height = 'auto'; }
          }, 320);
        } else {
          body.style.height = inner.offsetHeight + 'px';
          window.requestAnimationFrame(function () {
            body.style.height = '0px';
          });
        }
      }

      body.style.transition = 'height 0.3s cubic-bezier(0.22,0.61,0.36,1)';
      body.style.height = acc.open ? 'auto' : '0px';

      var summary = acc.querySelector('summary');
      if (!summary) { return; }

      summary.addEventListener('click', function (e) {
        e.preventDefault();
        var isOpen = acc.open;

        if (!isOpen) {
          accs.forEach(function (other) {
            if (other === acc || !other.open) { return; }
            var ob = other.querySelector('[data-gvp-acc-body]');
            var oi = ob ? ob.firstElementChild : null;
            if (ob && oi) {
              ob.style.height = oi.offsetHeight + 'px';
              window.requestAnimationFrame(function () { ob.style.height = '0px'; });
            }
            other.open = false;
          });
          acc.open = true;
          window.requestAnimationFrame(function () {
            body.style.height = '0px';
            window.requestAnimationFrame(function () { setHeight(true); });
          });
        } else {
          setHeight(false);
          window.setTimeout(function () { acc.open = false; }, 300);
        }
      });
    });

    /* ------------------------------------------------------------ variants */
    var form = root.querySelector('[data-gvp-form]');
    var idInput = root.querySelector('[data-gvp-id]');
    var priceEl = root.querySelector('[data-gvp-price]');
    var compareEl = root.querySelector('[data-gvp-compare]');
    var skuEl = root.querySelector('[data-gvp-sku]');
    var addBtn = root.querySelector('[data-gvp-add]');
    var radios = Array.prototype.slice.call(root.querySelectorAll('[data-gvp-optin]'));

    function money(cents) {
      var fmt = data.money_format || 'Rs. {{amount}}';
      var whole = Math.round(cents) / 100;
      var str = whole.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      var noDec = whole.toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
      return fmt
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDec)
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, str)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDec)
        .replace(/\{\{\s*amount\s*\}\}/g, str);
    }

    function selected() {
      var out = [];
      root.querySelectorAll('[data-gvp-optgroup]').forEach(function (g) {
        var checked = g.querySelector('input:checked');
        out.push(checked ? checked.value : null);
      });
      return out;
    }

    function findVariant(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var ok = true;
        for (var j = 0; j < opts.length; j++) {
          if (opts[j] === null || v.options[j] !== opts[j]) { ok = false; break; }
        }
        if (ok) { return v; }
      }
      return null;
    }

    function markAvailability(opts) {
      root.querySelectorAll('[data-gvp-optgroup]').forEach(function (g, gi) {
        g.querySelectorAll('[data-gvp-optin]').forEach(function (input) {
          var test = opts.slice();
          test[gi] = input.value;
          var possible = variants.some(function (v) {
            for (var j = 0; j < test.length; j++) {
              if (test[j] === null) { continue; }
              if (v.options[j] !== test[j]) { return false; }
            }
            return v.available;
          });
          var lbl = g.querySelector('label[for="' + input.id + '"]');
          if (lbl) { lbl.classList.toggle('gvp-unavailable', !possible); }
        });
      });
    }

    function update() {
      var opts = selected();
      markAvailability(opts);
      var v = findVariant(opts);

      if (!v) {
        if (addBtn) {
          addBtn.disabled = true;
          addBtn.textContent = data.labels && data.labels.unavailable ? data.labels.unavailable : 'Unavailable';
        }
        return;
      }

      if (idInput) { idInput.value = v.id; }
      if (priceEl) { priceEl.innerHTML = money(v.price); }
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.innerHTML = money(v.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (skuEl) { skuEl.textContent = v.sku || ''; }
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available
          ? (data.labels && data.labels.add ? data.labels.add : 'Add to cart')
          : (data.labels && data.labels.soldout ? data.labels.soldout : 'Sold out');
      }

      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    radios.forEach(function (r) { r.addEventListener('change', update); });
    if (radios.length) { update(); }

    if (form) {
      form.addEventListener('submit', function (e) {
        if (!idInput || !idInput.value) { e.preventDefault(); }
      });
    }

    /* --------------------------------------------- size chart (women only) */
    var sc = root.querySelector('[data-gvp-sc]');
    if (sc) { initSizeChart(sc); }

    function initSizeChart(sc) {
      var tabs = Array.prototype.slice.call(sc.querySelectorAll('[data-gvp-sc-tab]'));
      var unitBtns = Array.prototype.slice.call(sc.querySelectorAll('[data-gvp-sc-unit]'));
      var cells = Array.prototype.slice.call(sc.querySelectorAll('td[data-in]'));
      var rows = Array.prototype.slice.call(sc.querySelectorAll('[data-gvp-sc-size]'));
      var unitLabel = sc.querySelector('[data-gvp-sc-unit-label]');
      var sizeGroup = root.querySelector('[data-gvp-size-group]');
      var UNIT_KEY = 'gvpSizeUnit';

      /* XXL, 2xl and 2XL are the same size; compare on one spelling */
      function normSize(s) {
        var v = String(s || '').replace(/\s+/g, '').toUpperCase();
        var m = v.match(/^(X{2,})L$/);
        return m ? m[1].length + 'XL' : v;
      }

      function selectTab(i, focus) {
        if (!tabs[i]) { return; }
        tabs.forEach(function (t, ti) {
          var on = ti === i;
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          if (panel) { panel.hidden = !on; }
        });
        sc.setAttribute('data-gvp-sc-active', tabs[i].getAttribute('data-gvp-sc-tab'));
        if (focus) { tabs[i].focus(); }
      }

      tabs.forEach(function (t, ti) {
        t.addEventListener('click', function () { selectTab(ti, false); });
        t.addEventListener('keydown', function (e) {
          var next = null;
          if (e.key === 'ArrowRight') { next = (ti + 1) % tabs.length; }
          else if (e.key === 'ArrowLeft') { next = (ti - 1 + tabs.length) % tabs.length; }
          else if (e.key === 'Home') { next = 0; }
          else if (e.key === 'End') { next = tabs.length - 1; }
          if (next !== null) { e.preventDefault(); selectTab(next, true); }
        });
      });
      selectTab(0, false);

      function toCm(text) {
        return text.replace(/\d+(?:\.\d+)?/g, function (n) {
          return String(Math.round(parseFloat(n) * 2.54));
        });
      }

      function setUnit(unit, animate) {
        unitBtns.forEach(function (b) {
          b.setAttribute('aria-pressed', b.getAttribute('data-gvp-sc-unit') === unit ? 'true' : 'false');
        });
        cells.forEach(function (c) {
          var raw = c.getAttribute('data-in');
          if (raw) { c.textContent = unit === 'cm' ? toCm(raw) : raw; }
        });
        if (unitLabel) { unitLabel.textContent = unit === 'cm' ? 'centimetres' : 'inches'; }
        if (animate) {
          sc.classList.remove('is-swap');
          void sc.offsetWidth;
          sc.classList.add('is-swap');
        }
      }

      unitBtns.forEach(function (b) {
        b.addEventListener('click', function () {
          var unit = b.getAttribute('data-gvp-sc-unit');
          setUnit(unit, true);
          try { window.localStorage.setItem(UNIT_KEY, unit); } catch (err) { /* storage blocked */ }
        });
      });

      var saved = null;
      try { saved = window.localStorage.getItem(UNIT_KEY); } catch (err) { saved = null; }
      if (saved === 'cm') { setUnit('cm', false); }

      /* highlight the size picked on the page */
      function markSize() {
        var checked = sizeGroup ? sizeGroup.querySelector('input:checked') : null;
        var want = checked ? normSize(checked.value) : '';
        rows.forEach(function (r) {
          var on = want !== '' && normSize(r.getAttribute('data-gvp-sc-size')) === want;
          r.classList.toggle('is-current', on);
        });
      }

      if (sizeGroup) { sizeGroup.addEventListener('change', markSize); }
      sc.addEventListener('gvp:modal-open', markSize);
      markSize();
    }

    /* -------------------------------------------------------------- share */
    var toast = root.querySelector('[data-gvp-toast]');
    var copyBtn = root.querySelector('[data-gvp-copy]');

    function showToast(msg) {
      if (!toast) { return; }
      toast.textContent = msg;
      toast.hidden = false;
      window.requestAnimationFrame(function () { toast.classList.add('is-on'); });
      window.setTimeout(function () {
        toast.classList.remove('is-on');
        window.setTimeout(function () { toast.hidden = true; }, 260);
      }, 1700);
    }

    function legacyCopy(url) {
      var ta = document.createElement('textarea');
      ta.value = url;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.top = '-1000px';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      ta.setSelectionRange(0, ta.value.length);
      var done = false;
      try { done = document.execCommand('copy'); } catch (err) { done = false; }
      document.body.removeChild(ta);
      showToast(done ? 'Link copied' : 'Press and hold to copy');
    }

    if (copyBtn) {
      copyBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var url = window.location.href;
        if (navigator.clipboard && window.isSecureContext) {
          navigator.clipboard.writeText(url).then(function () {
            showToast('Link copied');
          }).catch(function () { legacyCopy(url); });
        } else {
          legacyCopy(url);
        }
      });
    }
  }

  ready(function () {
    Array.prototype.forEach.call(document.querySelectorAll('[data-gvp-root]'), init);
  });

  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-gvp-root]');
    if (r) { init(r); }
  });
})();
